(function() {
'use strict';

angular
    .module('TR')
    .directive('importantInfo', importantInfo);

function importantInfo(arrayUtil, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            info: '=',
            agentModeEnabled: '=?',
            contentCollapsible: '=',
            specialOfferText: '=?'
        },
        templateUrl: 'partials/home/directivetemplate?type=importantinfo',
        transclude: true,
        link: _linker
    };

    function _linker(scope) {
        scope.agentModeEnabled = !!$rootScope.user.Agent;

        // Special offer text
        if (scope.specialOfferText) {
            let offers = arrayUtil.wrapNonArray(scope.specialOfferText);
            scope.specialOfferHtml = offers.reduce((html, t) => {
                if (t) {
                    return `${html} <div>${t}</div>`;
                }
                return html;
            }, '');
        }
    }
}
})();
